import {LegalDisclaimer} from '@github-ui/copilot-chat/components/LegalDisclaimer'
import CopilotIconAnimation from '@github-ui/copilot-chat-visuals/CopilotIconAnimation'
import {useState} from 'react'

import {useCopilotContext} from './../contexts/CopilotContext'
import styles from './ChatContent.module.css'
import {ChatInput, type ChatInputProps} from './ChatInput'
import {SignInDialog} from './SignInDialog'
import {Suggestions} from './Suggestions'

export const ChatContent = ({initialModelId}: {initialModelId?: ChatInputProps['currentModelId']}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const {prompt, setPrompt} = useCopilotContext()

  return (
    <div className={styles.wrapper}>
      <div className={styles.stackWrapper}>
        <div>
          <CopilotIconAnimation hidden />
        </div>

        <Suggestions
          onSuggestionClick={message => {
            setPrompt(message)
            setIsDialogOpen(true)
          }}
        />

        <div className={styles.legalDisclaimer}>
          <LegalDisclaimer />
        </div>
      </div>

      <div className={styles.footer}>
        <ChatInput
          currentModelId={initialModelId}
          prompt={prompt}
          onPromptChange={setPrompt}
          onOpenDialog={() => setIsDialogOpen(true)}
          onModelClick={() => null}
        />
      </div>

      {isDialogOpen && <SignInDialog onClose={() => setIsDialogOpen(false)} />}
    </div>
  )
}
